import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mini-env-heading-block',
  imports: [CommonModule],
  templateUrl: './mini-env-heading-block.component.html',
  styleUrl: './mini-env-heading-block.component.scss'
})
export class MiniEnvHeadingBlockComponent {
  @Input() miniTitle: string | null = '';
  @Input() class: string | null = '';
  @Input() title: string | null = '';
  @Input() description: string | null = '';
  @Input() style: string | object = '';
    @Input() discription: string | object = '';
  @Input() descriptionstyle: string | object = '';
  @Input() headingStyle: string | null = ''
  @Input() mainheading: string | null = '';
  @Input() mainiheading : string | null = '';
  @Input() sectionheading : string | null ='';
  @Input() leftAlign = false;
}
